/** Task detail host: the dialog shell loads with the app; the detail itself loads on first open. */
import { Suspense, lazy } from 'react';
import { Dialog as D } from 'radix-ui';
import { cn } from '@/lib/cn';
import { useIsDesktop } from '@/lib/hooks';
import { useCloseTask, useOpenTaskId } from '@/routes/nav';

const TaskDetail = lazy(() => import('./TaskDetail'));

export function TaskDetailHost() {
  const taskId = useOpenTaskId();
  const close = useCloseTask();
  const desktop = useIsDesktop();
  return (
    <D.Root open={!!taskId} onOpenChange={(o) => !o && close()}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 bg-overlay" />
        <D.Content
          aria-describedby={undefined}
          className={cn(
            'fixed z-40 flex flex-col overflow-hidden bg-raised text-ink shadow-modal outline-none',
            desktop
              ? 'top-[4vh] left-1/2 h-[92vh] w-[min(1120px,calc(100vw-48px))] -translate-x-1/2 rounded-lg'
              : 'inset-0 rounded-none',
          )}
        >
          <Suspense fallback={<D.Title className="p-6 text-ink-3">Loading task…</D.Title>}>
            {taskId && <TaskDetail taskId={taskId} onClose={close} desktop={desktop} />}
          </Suspense>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
